import { render, staticRenderFns } from "./CarouselComp.vue?vue&type=template&id=db4e9040&scoped=true"
import script from "./CarouselComp.vue?vue&type=script&lang=js"
export * from "./CarouselComp.vue?vue&type=script&lang=js"
import style0 from "./CarouselComp.vue?vue&type=style&index=0&id=db4e9040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4e9040",
  null
  
)

export default component.exports